module.exports = "/_next/static/files/fea189b4ba8aab73458925d2c1a08675.jpg";